export default {
  label: 'CPF',
  hint: 'Deine Bank braucht für diese Zahlung deine CPF. Wir geben sie weiter und speichern sie nicht.',
  invalid: 'Das ist keine gültige CPF. Prüfe die 11 Ziffern.',
};
